export default ({ fetchSuccessTypes, updateSuccessTypes, removeType, resetType, entityType, updateKey }) => {
  const INITIAL_STATE = {};

  return (state = INITIAL_STATE, action) => {
    if(fetchSuccessTypes.indexOf(action.type) >= 0) {
      const entities = action.result.entities[entityType];
      const newState = {...state};

      if(entities) {
        Object.keys(entities).forEach(id => {
          return newState[id] = {
            ...newState[id],
            ...entities[id]
          };
        });
      }

      return newState;
    }

    if(updateSuccessTypes && updateSuccessTypes.indexOf(action.type) >= 0) {
      return {
        ...state,
        [action[updateKey]]: {
          ...state[action[updateKey]],
          ...action.updates
        }
      };
    }

    switch(action.type) {
      case removeType: {
        const { [action.id]: omitId, ...withoutId } = state; // eslint-disable-line no-unused-vars
        return withoutId;
      }

      case resetType: {
        return INITIAL_STATE;
      }

      default:
        return state;
    }
  };
};



/** WEBPACK FOOTER **
 ** ./src/members/state/__shared__/reducersMakers/byIdMaker.js
 **/